module.exports = __webpack_public_path__ + "img/ball-tb.d15e780f.svg";